module.exports = __webpack_public_path__ + "static/media/1_portrait.a6cb3845.jpg";